import { M19Route } from "@m19-board/utils/M19Route";
import { AccountLinkingPageComponent } from "@m19-board/onboarding/account-linking-page.component";
import { StatsDownloadingPageComponent } from "@m19-board/onboarding/stats-downloading-page.component";
import { OnboardingCallPageComponent } from "@m19-board/onboarding/onboarding-call-page.component";
import { FreeTestPageComponent } from "@m19-board/onboarding/free-test-subscription-page.component";
import { WhitelabelNoAccountPageComponent } from "@m19-board/onboarding/whitelabel-noaccount-page.component";
import { NoAccountsPageComponent } from "@front/m19-ui";

export const onboardingRoutes: M19Route[] = [
  {
    path: "account-linking",
    component: AccountLinkingPageComponent,
    title: "Link your Amazon accounts",
    data: {
      fromOnboarding: true,
    },
  },
  {
    path: "downloading-stats",
    component: StatsDownloadingPageComponent,
    title: "Downloading Stats",
  },
  {
    path: "onboarding-call",
    component: OnboardingCallPageComponent,
    title: "Free Onboarding Call",
  },
  {
    path: "free-test-subscription",
    component: FreeTestPageComponent,
    title: "Free Test Subscription",
  },
  {
    path: "agency-no-account",
    component: WhitelabelNoAccountPageComponent,
    title: "No Accounts",
  },
  {
    path: "no-account",
    component: NoAccountsPageComponent,
    title: "No Accounts",
    data: {
      reconnectRoute: ["/onboarding/account-linking"],
    },
  },
];
